import React, {
  SyntheticEvent,
  useState,
  useRef,
  Fragment,
  useId,
} from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Button } from '@app/core';
import { MenuItem, MenuWindow } from 'components';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {},
  icon: {
    marginLeft: theme.marginBase,
  },
}));

interface Props {
  onSelect: (count: number) => void;
}

export const SelectionMenu = ({ onSelect }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  const [anchorElmnt, setAnchorElmnt] = useState<null | Element>(null);
  const id = useId();

  const onClick = (event: SyntheticEvent) => {
    event.stopPropagation();
    setAnchorElmnt(event.currentTarget);
  };
  const onClose = (event: SyntheticEvent) => {
    event.stopPropagation();
    setAnchorElmnt(null);
  };

  const createOnSelect = (count: number) => () => onSelect(count);

  return (
    <Fragment>
      <Button
        color="inkSecondary"
        small
        onClick={onClick}
        aria-controls={id}
        aria-haspopup="true"
      >
        {t('sessions.details.invitationQueue.invite.selectButton')}
        <i className={classnames('ri-arrow-down-s-line', classes.icon)} />
      </Button>
      <MenuWindow
        open={!!anchorElmnt}
        onClose={onClose}
        id={id}
        anchorEl={anchorElmnt}
        onClick={onClose}
      >
        {[10, 20, 50, 100].map((count) => (
          <MenuItem
            label={t('sessions.details.invitationQueue.invite.select', {
              count,
            })}
            onClick={createOnSelect(count)}
            key={count}
          />
        ))}
      </MenuWindow>
    </Fragment>
  );
};
